import useAuthProvider from "./useAuthProvider";

const useGetIdentity = () => {
  const authProvider = useAuthProvider();
  return authProvider.user;
};

export default useGetIdentity;
